import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { Underground } from '../../Underground';
import * as styles from './OfferRecommendation.css';
export var OfferRecommendation = function OfferRecommendation(_ref) {
  var recommendation = _ref.recommendation;
  var newbuildingName = recommendation.newbuildingName,
      underground = recommendation.underground,
      formattedPrice = recommendation.formattedPrice,
      title = recommendation.title,
      photoUrl = recommendation.photoUrl;
  var displayName = newbuildingName && "\u0416\u041A \xAB".concat(newbuildingName, "\xBB");
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container'],
    "data-testid": "offer-recommendation"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['image'],
    style: {
      backgroundImage: "url(".concat(photoUrl, ")")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content-item']
  }, /*#__PURE__*/React.createElement(UIText2, {
    fontWeight: "bold",
    display: "block"
  }, formattedPrice)), /*#__PURE__*/React.createElement("div", {
    className: styles['content-item']
  }, /*#__PURE__*/React.createElement(UIText2, {
    display: "block"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['text']
  }, title))), displayName && /*#__PURE__*/React.createElement("div", {
    className: styles['content-item']
  }, /*#__PURE__*/React.createElement(UIText2, {
    display: "block"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['text']
  }, displayName)))), underground && underground.name && underground.color && /*#__PURE__*/React.createElement(Underground, {
    color: underground.color,
    name: underground.name,
    transportType: underground.transportType,
    time: underground.time
  }));
};